import { ISOFILEMANAGMENT } from "./actions";

export const fetchFileList = (pageNumber: number, status?: boolean) => {
  return {
    type: ISOFILEMANAGMENT.FETCH_MANAGEMENT_LIST,
    payload: { pageNumber, status }
  };
};

export const getFileList = (list: any, status?: boolean) => {
  return {
    type: ISOFILEMANAGMENT.FILE_MANAGEMENT_LIST,
    payload: list,
    status: status
  };
};

export const pageDetails = (pageNumber: number, totalPages: number, totalRecords: number) => {
  return {
    type: ISOFILEMANAGMENT.PAGE_DETAILS,
    payload: { pageNumber, totalPages, totalRecords },
  };
};



export const uploadFile = (file: any) => {
  return {
    type: ISOFILEMANAGMENT.UPLOAD_FILE,
    payload: file,
  };
}

export const deleteList = (ids: any[]) => {
  return {
    type: ISOFILEMANAGMENT.DELETE_LIST,
    payload: ids,
  };
}

export const deleteMultipleList = (ids: any[]) => {
  return {
    type: ISOFILEMANAGMENT.DELETE_MULTIPLE_LIST,
    payload: ids,
  };
}

export const localSearch = (value: string) => {
  return {
    type: ISOFILEMANAGMENT.LOCAL_SEARCH,
    payload: value,
  };
}

export const checkAllCheckbox = (value: boolean) => {
  return {
    type: ISOFILEMANAGMENT.CHECK_ALL_CHECKBOX,
    payload: value,
  };
}

export const checkSingleCheckbox = (id: number, value: boolean) => {
  return {
    type: ISOFILEMANAGMENT.CHECK_SINGLE_CHECKBOX,
    payload: { id, value },
  };
};

export const sortingOrder = (direction: "asc" | "desc", key: string) => {
  return {
    type: ISOFILEMANAGMENT.SORTING_ORDER,
    payload: { direction, key },
  };
};
export const downloadIsoFile = (file: any) => {
  return {
    type: ISOFILEMANAGMENT.FETCH_DOWNLOAD_LIST,
    payload: file,
  };
};

export const searchText = (value: string) => {
  return {
    type: ISOFILEMANAGMENT.SEARCH_VALUE,
    payload: value,
  };
};

export const uploadLoader = (percentage: string,uploadMB: string,totalMB: string,name: string) => {
  return {
    type: ISOFILEMANAGMENT.UPLOAD_LOADER,
    payload: { percentage, uploadMB, totalMB,name },
  };
};

export const cancelUpload = (jobId: number) => {
  return {
    type: ISOFILEMANAGMENT.CANCEL_ISO_UPLOAD,
    payload: { jobId },
  };
};
